// import { Routes, Route, BrowserRouter } from 'react-router-dom'
import { Routes, Route, BrowserRouter, Outlet } from 'react-router-dom'
import Layout from '../layout/Layout'

// import ConnectWallet from '../pages/ConnectWallet'
// import MintPage from '../pages/MintPage'
import BuyToken from '../pages/BuyToken'
const Routers = () => {
  const Component = () => {
    // let token = localStorage.getItem('token')
    // if (token) return <Navigate to={'/dashboard'} />
    // else
    return (
      <Layout>
        <Outlet />
      </Layout>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Uncommit next line to apply token security */}
        {/* <Route element={<PrivateWrapper />}>
          <Route path='/dashboard' element={<Dashboard />} />
        </Route> */}

        <Route element={<Component />}>
          <Route path='/' element={<BuyToken />} />
          {/* <Route path='/connect-wallet' element={<MintPage />} /> */}
          {/* <Route path='/connect-wallet' element={<BuyToken />} /> */}
          {/* <Route path='/buy-token' element={<BuyToken />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Routers
